import HTTP from "../http";
import Jsona from "jsona";
import moment from "moment-business-days";

const dataFormatter = new Jsona();

export default {
  async getPayment(payment_id) {
    try {
      let payment = await HTTP.normal.get(
        `/payments/${payment_id}?include=funding_instrument`
      );
      return dataFormatter.deserialize(payment.data);
    } catch (e) {
      throw e.response.data;
    }
  },

  async paymentViaBoleto(payable) {
    try {
      let expiration_date = moment(payable.starts_at).businessSubtract(3);

      if (
        payable.type == "cycle" &&
        payable.subscription.payment_emission_day != 28
      )
        expiration_date = moment(payable.starts_at).set({
          date: payable.subscription.payment_emission_day
        });

      if (payable.type == "order" || expiration_date < moment())
        expiration_date = moment().businessAdd(1);

      let data = {
        data: {
          type: "payments",
          relationships: {
            payable: {
              data: {
                id: payable.id,
                type: payable.type
              }
            },
            funding_instrument: {
              attributes: {
                expiration_date
              }
            }
          }
        }
      };

      let boleto = await HTTP.normal.post(`/payments/boleto`, data);
      return dataFormatter.deserialize(boleto.data);
    } catch (e) {
      throw e.response.data;
    }
  },

  async paymentViaCreditCard(payload) {
    try {
      let data = payload.data;
      let payable = payload.payable;

      let cc = new Moip.CreditCard({
        number: data.number,
        cvc: data.cvc,
        expMonth: data.deadline_month,
        expYear: data.deadline_year,
        pubKey: process.env.WIRECARD_PUB_KEY
      });

      if (!cc.isValid()) throw "Cartão Inválido!";

      let document_type = data.document.length > 11 ? "CNPJ" : "CPF";

      let body = {
        data: {
          type: "payments",
          relationships: {
            payable: {
              data: {
                type: payable.type === "orders" ? "order" : "cycle",
                id: payable.id
              }
            },
            funding_instrument: {
              data: {
                type: "credit_card"
              },
              attributes: {
                store: false,
                hash: cc.hash(),
                holder: {
                  phone: data.phone,
                  address: {
                    street: payable.address.street,
                    street_number: payable.address.street_number,
                    zip_code: payable.address.zip_code,
                    complement: payable.address.complement,
                    district: payable.address.district.display_name,
                    city: payable.address.district.city.display_name,
                    state: payable.address.district.city.state.code,
                    country: payable.address.district.city.state.country.code
                  },
                  full_name: data.name,
                  birthdate: data.birthdate,
                  document_type,
                  document_number: data.document
                }
              }
            }
          }
        }
      };

      let res = await HTTP.normal.post(`/payments/credit-card/new`, body);
      return dataFormatter.deserialize(res.data);
    } catch (e) {
      throw e.response.data;
    }
  }
};



// WEBPACK FOOTER //
// ./src/api/modules/payments.js